(function () {
  if (window.__pawrampIntentInitialized) return;
  window.__pawrampIntentInitialized = true;

  function getVariantFromElement(element) {
    var section = element.closest('[data-pawramp-buy-box]');
    if (!section) return {};

    var form = section.querySelector('form[action*="/cart/add"]');
    var variantInput = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
    var variantPicker = section.querySelector('variant-radios, variant-selects');
    var variantTitle = '';
    var price = section.querySelector('.rc-price, .price-item--sale, .price-item--regular');

    if (variantPicker && variantPicker.currentVariant) {
      variantTitle = variantPicker.currentVariant.title || variantPicker.currentVariant.options.join(' / ');
    }

    return {
      variant_id: variantInput ? variantInput.value : '',
      variant_title: variantTitle,
      price: price ? price.textContent.trim() : ''
    };
  }

  function track(eventName, element, extra) {
    var pageSection = element.closest('[data-pawramp-angle]');
    var buyBox = element.closest('[data-pawramp-buy-box]');
    var source = pageSection || buyBox || element;
    var variantData = getVariantFromElement(element);
    var detail = Object.assign({
      event: eventName,
      angle: source ? source.dataset.pawrampAngle || source.dataset.angle || '' : '',
      page_url: window.location.pathname,
      product_handle: source ? source.dataset.product || 'pawramp' : 'pawramp'
    }, variantData, extra || {});

    document.dispatchEvent(new CustomEvent(eventName, { detail: detail }));

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(detail);
    }
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-pawramp-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('.pawramp-intent-main-product__media-column, .pawramp-intent-buy-box__media-column');
      var mainImage = gallery ? gallery.querySelector('.pawramp-intent-gallery__main') : null;

      if (mainImage && thumb.dataset.fullImage) {
        mainImage.src = thumb.dataset.fullImage;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumb.dataset.alt || mainImage.alt;

        gallery.querySelectorAll('[data-pawramp-gallery-thumb]').forEach(function (button) {
          var isSelected = button === thumb;
          button.classList.toggle('is-active', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }
    }

    var trigger = event.target.closest('[data-pawramp-track]');
    if (!trigger) return;

    track(trigger.dataset.pawrampTrack, trigger);

    if (trigger.hash && trigger.hash.charAt(0) === '#') {
      var target = document.querySelector(trigger.hash);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('change', function (event) {
    var picker = event.target.closest('variant-radios, variant-selects');
    if (!picker || !picker.closest('[data-pawramp-buy-box]')) return;

    track('pawramp_intent_variant_change', picker);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pawramp-buy-box]').forEach(function (buyBox) {
      track('pawramp_intent_page_view', buyBox);
    });
  });
})();
